import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  PlaceholderInput,
  PlaceholderTabla,
} from "../../components/Otros/Placeholder";
import {
  cargarPorRatificar,
  cargarProcesoActivo,
  cargarRatificadas,
  cerrarProceso,
} from "../../utils/Datos";
import { UrlWs } from "../../utils/Global";
import Swal from "sweetalert2";
//
export const ListarRatificadas = () => {
  const [listaRatificadas, setListaRatificadas] = useState(null);
  const [listaPorRatificar, setListaPorRatificar] = useState(null);
  const [procesoActivo, setProcesoActivo] = useState(null);
  const navigate = useNavigate();

  const handleClick = (id_participant) => {
    const url =`/verProcesoFuncionario/${
      procesoActivo != null ? procesoActivo.id_process : 0
    }/${id_participant}`;
    navigate(url);
  };

  const handleCerrarProceso = ()=>{
    if (procesoActivo!=null) {
        console.log('proceso activo',procesoActivo);
    }
    cerrarProceso(procesoActivo.id_process).then((x)=>{
      Swal.fire({
        title: "Listo",
        text: "Proceso cerrado correctamente",
        icon: "success",
        confirmButtonText: "Ok",
      }).then((okay) => {
        if (okay) {
          window.location.href = "/home";
        }
      });
    })
  }

  useEffect(() => {
    cargarProcesoActivo().then((datos) => {
      cargarRatificadas(datos.id_process).then((respuesta) => {
        if (respuesta.status === true) {
          setListaRatificadas(respuesta.datos);
        } else {
          setListaRatificadas([]);
        }
      });
      cargarPorRatificar(datos.id_process).then((respuesta) => {
        if (respuesta.status === true) {
          setListaPorRatificar(respuesta.datos);
        } else {
          setListaPorRatificar([]);
        }
      });
      setProcesoActivo(datos);
    });
  }, []);

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
              GESTIÓN PROCESO ACTIVO
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark"> -</li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                       INFORMACIÓN DEL PROCESO
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row mb-8">
                    {procesoActivo != null ? (
                      <>
                        <div className="col-lg-3 col-sm-12 ">
                          <label className="form-label">Año del proceso</label>
                          {procesoActivo != null ? (
                            <input
                              className="form-control mb-5"
                              aria-label=""
                              disabled={true}
                              type="text"
                              defaultValue={procesoActivo.yearProcess}
                            />
                          ) : (
                            <PlaceholderInput></PlaceholderInput>
                          )}
                        </div>
                        <div className="col-lg-6 col-sm-12 ">
                          <label className="form-label">
                            Nombre del proceso
                          </label>
                          {procesoActivo != null ? (
                            <input
                              type="text"
                              className="form-control mb-5"
                              disabled={true}
                              defaultValue={procesoActivo.name}
                            />
                          ) : (
                            <PlaceholderInput></PlaceholderInput>
                          )}
                        </div>

                        <div className="col-lg-3 col-sm-12 ">
                          <label className="form-label">Estado</label>
                          {procesoActivo != null ? (
                            <input
                              type="text"
                              className="form-control mb-5"
                              disabled={true}
                              defaultValue={procesoActivo.processStatus}
                            />
                          ) : (
                            <PlaceholderInput></PlaceholderInput>
                          )}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row mb-8">
                    <div className="rounded border p-10 pb-10 d-flex flex-wrap justify-content-between">
                      <div>
                        <span className="menu-link me-5">
                          <span className="menu-icon">
                            <span className="svg-icon svg-icon-6 svg-icon-info me-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                          </span>
                          <span className="menu-title fw-bold">
                            Total Proceso:
                          </span>
                          <span className="badge badge-light-info">
                            {listaRatificadas === null ||
                            listaPorRatificar === null
                              ? "-"
                              : listaRatificadas?.length +
                                listaPorRatificar?.length}
                          </span>
                        </span>
                        <span className="menu-link me-5">
                          <span className="menu-icon">
                            <span className="svg-icon svg-icon-6 svg-icon-success me-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                          </span>
                          <span className="menu-title fw-bold ">
                            Ratificaciones:
                          </span>
                          <span className="badge badge-light-success">
                            {listaRatificadas === null
                              ? "-"
                              : listaRatificadas?.length}
                          </span>
                        </span>
                        <span className="menu-link me-5">
                          <span className="menu-icon">
                            <span className="svg-icon svg-icon-6 svg-icon-danger me-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.3 6 12 6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                          </span>
                        </span>
                        <span className="menu-title fw-bold">
                          Por ratificar:
                        </span>
                        <span className="badge badge-light-danger">
                          {listaPorRatificar === null
                            ? "-"
                            : listaPorRatificar?.length}
                        </span>
                      </div>
                      {procesoActivo != null &&
                      listaPorRatificar != null && 
                      listaPorRatificar.length <= 0 ? (
                        <button
                          onClick={handleCerrarProceso}
                          className="btn btn-primary"
                        >
                          Cerrar proceso
                        </button>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header ">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                      GESTIÓN DE NOTIFCACIONES EN PROCESO
                    </span>
                  </h3>
                </div>
                <div className="card-body ">
                  <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 ">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        href="#por-ratificar"
                      >
                        Por rartificar
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className="nav-link "
                        data-bs-toggle="tab"
                        href="#ratificadas"
                      >
                        Ratificadas
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="tabruth">
                    <div
                      className="tab-pane fade "
                      id="ratificadas"
                      role="tabpanel"
                    >
                      {listaRatificadas != null ? (
                        <TablaRatificadas
                          listaRatificadas={listaRatificadas}
                          handleClick={handleClick}
                        ></TablaRatificadas>
                      ) : (
                        <>
                          <PlaceholderTabla></PlaceholderTabla>
                        </>
                      )}
                    </div>
                    <div
                      className="tab-pane fade show active"
                      id="por-ratificar"
                      role="tabpanel"
                    >
                      {listaPorRatificar != null ? (
                        <TablaPorRatificar
                          listaPorRatificar={listaPorRatificar}
                          handleClick={handleClick}
                        ></TablaPorRatificar>
                      ) : (
                        <>
                          <PlaceholderTabla></PlaceholderTabla>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TablaRatificadas = ({ listaRatificadas, handleClick }) => {
  return (
    <div className="table-responsive">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th>Rut</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Unidad</th>
            <th>Precalificador</th>
            <th>Verificar</th>
          </tr>
        </thead>
        <tbody>
          {listaRatificadas.length > 0 ? (
            listaRatificadas.map((d) => {
              return (
                <tr key={d.id_qualifications}>
                  <td>{d.rutOfficer}</td>
                  <td>{d.nameOficcer}</td>
                  <td>{d.nameDmunicipal}</td>
                  <td>{d.nameUmunicipal}</td>
                  <td>{d.namePrequalifier}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark "
                      onClick={() => handleClick(d.id_participant)}
                    >
                       Ver
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6}>No hay datos para mostrar</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export const TablaPorRatificar = ({ listaPorRatificar, handleClick }) => {
  return (
    <div className="table-responsive">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th>Rut</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Unidad</th>
            <th>Precalificador</th>
            <th>Verificar</th>
          </tr>
        </thead>
        <tbody>
          {listaPorRatificar.length > 0 ? (
            listaPorRatificar.map((d) => {
              return (
                <tr key={d.id_qualifications}>
                  <td>{d.rutOfficer}</td>
                  <td>{d.nameOficcer}</td>
                  <td>{d.nameDmunicipal}</td>
                  <td>{d.nameUmunicipal}</td>
                  <td>{d.namePrequalifier}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark "
                      onClick={() => handleClick(d.id_participant)}
                    >
                       Ver
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6}>No hay datos para mostrar</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
